export default {"src":"/_next/static/media/website-icon.b64f4d3c.svg","height":513,"width":513};